/**
 * @file コンポーネント：フル動画ページボタンリスト ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Buttonlist = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
